"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var scenario_state_1 = require("../../redux/scenario/scenario.state");

var editable_action_view_styles_1 = require("./editable-action-view.styles");

var move_next_node_button_container_1 = __importDefault(require("../move-next-node-button/move-next-node-button.container"));

var set_action_url_button_container_1 = __importDefault(require("../set-action-url-button/set-action-url-button.container"));

var add_action_button_container_1 = __importDefault(require("../add-action-button/add-action-button.container"));

var remove_node_button_container_1 = __importDefault(require("../remove-node-button/remove-node-button.container"));

var EditableActionView = function EditableActionView(_ref) {
  var nodeId = _ref.nodeId,
      optionIndex = _ref.optionIndex,
      _ref$option = _ref.option,
      actionType = _ref$option.actionType,
      actionId = _ref$option.actionId,
      actionUrl = _ref$option.actionUrl,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'row' : _ref$direction;
  return react_1.default.createElement(editable_action_view_styles_1.StyledActionViewWrapperDiv, {
    "data-meta": "editable-action-view",
    direction: direction
  }, react_1.default.createElement(editable_action_view_styles_1.StyledFontAwesomeIcon, {
    icon: 'angle-double-right'
  }), actionType === scenario_state_1.ActionType.Id && !!actionId ? react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(move_next_node_button_container_1.default, {
    nextNodeId: actionId
  }), react_1.default.createElement(remove_node_button_container_1.default, {
    nodeId: actionId
  })) : actionType === scenario_state_1.ActionType.Url && !!actionUrl ? react_1.default.createElement(set_action_url_button_container_1.default, {
    nodeId: nodeId,
    optionIndex: optionIndex
  }) : react_1.default.createElement(add_action_button_container_1.default, {
    nodeId: nodeId,
    optionIndex: optionIndex
  }));
};

exports.default = EditableActionView;